import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import TraderListLayer from "../components/TraderListLayer";
import CourseViewLayer from "../components/CourseViewLayer";


const ViewCoursePage = () => {
  return (
    <>
     
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Trader List" /> */}
        <div className="d-flex justify-content-between"><h5>View Course  </h5><Breadcrumb title="View Course" /></div>

        <CourseViewLayer/>

    
    </>
  );
};


export default ViewCoursePage;
